import React from 'react';
import mescalineOne from '../../assets/images/Menu/Drugs/mescalineTeaText/one.jpeg';
import mescalineTwo from '../../assets/images/Menu/Drugs/mescalineTeaText/two.png';
import mescalineThree from '../../assets/images/Menu/Drugs/mescalineTeaText/three.jpeg';
import mescalineFour from '../../assets/images/Menu/Drugs/mescalineTeaText/four.jpeg';
import mescalineFive from '../../assets/images/Menu/Drugs/mescalineTeaText/five.jpeg';

import cocaineOne from '../../assets/images/Menu/Drugs/acetoneWashCokeText/one.jpg';
import cocaineTwo from '../../assets/images/Menu/Drugs/acetoneWashCokeText/two.jpg';
import cocaineThree from '../../assets/images/Menu/Drugs/acetoneWashCokeText/three.jpg';
import cocaineFour from '../../assets/images/Menu/Drugs/acetoneWashCokeText/four.jpg';
import cocaineFive from '../../assets/images/Menu/Drugs/acetoneWashCokeText/five.jpg';
import cocaineSix from '../../assets/images/Menu/Drugs/acetoneWashCokeText/six.jpg';
import cocaineSeven from '../../assets/images/Menu/Drugs/acetoneWashCokeText/seven.jpg';

export function mescalineTea() {
	return (
		<div>
			<h1>How to Make Mescaline Tea</h1>
			<h2>Acquiring San Pedro</h2>
			<p>
				San Pedro is a cactus sometimes found in regular hardware stores in the
				outdoor section. You can also use Peruvian Torch cactus. Please refrain
				from using Peyote, as it is endangered and extremely fragile, as well as
				slow growing. San Pedro and Peruvian Torch grow like weeds in
				comparison.
				<br />
				San Pedro and Peruvian Torch cacti are often found online for purchase
				as well, which is an option if sourcing is an issue.
				<br />
				<br />
				<b>Citation:</b> @jerrytoth via
				https://medium.com/@jerrytoth/diy-mescaline-how-to-explore-san-pedro-without-a-guide-ba74e852b455
				<br />
				Visit the citation for a more in depth look at harvesting, usage, etc..
			</p>
			<h2>Preparing the Cactus</h2>
			<p>
				Ideally, you’ll want to lodge in a place where you have free reign of
				the kitchen for about eight hours. That’s the time it will take you to
				prepare the cactus and boil it down. The only equipment you need is a
				knife, a stove or fire pit, a pot, water, and a strainer. Anyone can do
				it.
				<br />
				<br />
				<img src={mescalineOne} alt="Freshly despined cactus." />
				The outermost layer is translucent, and somewhat waxy. Think of it as
				the skin of the cactus. The green layer immediately beneath the skin is
				where the mescaline is concentrated — this is the flesh. The white pulp
				below the flesh is best avoided because it only contains a marginal
				amount of mescaline and tends to cause nausea.
				<br />
				<br />
				The first step is to remove the spines from the cactus. Use the tip of a
				small knife for this. Remove each spine, one by one, and discard them.
				(If you’re lazy, you can skip this step, without much detriment to the
				final brew.) The second step is to remove the thin, semi-translucent
				waxen layer of skin that encases the cactus. It’s almost like removing
				dead skin that’s starting to peel after a sunburn — which I say only to
				illustrate how thin this layer is and also how it is best removed. Use a
				knife to get under this thin layer and peel it off. You don’t need this
				for your brew, so you can return it to the land.
				<br />
				<br />
				<img src={mescalineTwo} alt="Removing the clear layer." />
				The translucent skin can often be removed by hand, revealing a layer of
				wet, dark green flesh beneath it. That’s the part you want to extract.
				<br />
				<br />
				Once the waxy skin is removed, a layer of wet green flesh will be fully
				exposed — and this is what you want. This layer of green flesh only
				extends a few millimeters deep. Below the green flesh is a layer of
				white pulp. Use a knife to remove the green layer, but not the white
				layer. Inevitably, some of your green cuttings will include some of the
				white pulp, and this is okay. The white pulp won’t hurt you, but it may
				add to the nausea. Almost all of the mescaline is stored in the green
				flesh, so this is what you’re after. Try not to miss any of the green —
				you want all of it.
				<br />
				<br />
				<img src={mescalineThree} alt="Removing the green layer." />
				The goal is to try to extract as much green as possible, without dipping
				into the white, but it doesn’t need to be perfect. Just do your best.
				It’s inevitable that some of the white pulp will make it into your brew.
				<br />
				<br />
				By the end of this process, you will have a bowl full of green slices of
				cactus. Imagine if you were shaving the external part of a carrot, but
				instead of using a vegetable peeler, you use a knife, and thus your
				shavings are slightly thicker. That’s pretty much what the green
				shavings will look like, in terms of their size and width.
				<br />
				<br />
				<img src={mescalineFour} alt="Cactus, seperated by layers." />
				The green shavings (in the clay bowl to the left) go into the pot to
				boil. Everything else is returned to the earth.
			</p>
			<h2>San Pedro Tea</h2>
			<p>
				Put these shavings into a big pot with about three liters of water, and
				put this pot over a medium flame. After three to four hours, you will
				have about one cup of green liquid — about 250 ml. Pour this concoction
				through a strainer and let the liquid cool
				<br />
				<br />
				But you’re not done yet! Put the cactus shavings back into the pot and
				add another two liters of water, and do a second boiling. For the second
				boiling, I always only do it for two hours, and this has always worked.
				Once the two hours are up, pour the liquid through a strainer and mix it
				with the first batch of liquid. After a combined five to six hours of
				boiling, I usually end up with approximately 400 ml of green liquid in
				total. During my most recent ceremony, I boiled it down until I had a
				total of about 300 ml. It helps to reduce the liquid as much as
				possible, because less volume means that it’s quicker to drink. It also
				means that your stomach will be loaded down with less water during your
				trip, which helps reduce the chances of nausea. In summary: aim for
				250–500 ml of concentrated liquid at the end of boiling.
				<br />
				<br />
				<b>Warning:</b> You will need to be very vigilant toward the end of each
				boiling cycle. If you fall asleep on the job, you may accidentally boil
				off all of the liquid, effectively ruining the whole process. It takes
				about three hours to reduce three liters of water to 500 ml. If you want
				to play it safe, turn off the flame at that point and pour it through a
				strainer, to see how much liquid is left. If it’s 500 ml or more, return
				it to the pot and continue boiling a little bit longer, until it’s only
				250 ml (i.e., one cup). If it’s already around one cup, then stop there,
				store the liquid in a container, and begin the second boiling.{' '}
				<img src={mescalineFive} alt="Dried cactus powder." />
				One arms-length piece of cactus dehydrated and pulverized into 20 grams
				of pure green(ish) powder.
			</p>
			<h2>Alternative Preparation Methods</h2>
			<p>
				Making “tea” is not the only way to prepare San Pedro. There’s one
				technique that employs a blender and another technique that involves
				drying the green flesh and grinding it into a powder. All of the above
				work, but the method I use has worked so perfectly for me, every single
				time, that I see no need to deviate from it even to the slightest
				degree. The blender technique, on the other hand, seems to provoke more
				nausea, probably because more of the white pulp makes its way into the
				final brew. Recently I’ve been experimenting with the drying method,
				with good results. You can learn more about that process in my article
				Macro-Dosing Mescaline: The danger of not consuming enough San Pedro.
				<br />
				https://medium.com/@jerrytoth/macro-dosing-mescaline-the-danger-of-not-consuming-enough-san-pedro-aaaf89d4004c
			</p>
			<h2>Set and Setting</h2>
			<p>
				Once I’ve finished boiling down the potion, I let this sit overnight. I
				eat a light, healthy dinner and get a good night’s sleep. The journey
				will begin the following morning.
				<br />
				<br /> This brings us to the matter of set and setting. It is absolutely
				imperative to choose a beautiful, peaceful, and secluded place outside.
				You’re basically going to spend the entire day making love with the
				natural world, so choose this place very wisely. You want it to be a
				place where it’s comfortable to do things like lie down on the ground
				and kiss flowers and stuff (seriously). It’s okay to have a house or hut
				or tent nearby, to serve as home-base during the more reflective second
				half of the experience. But even your shelter should feel open and
				connected to the outside. In my opinion, consuming San Pedro in an urban
				and/or indoor environment is a terrible idea and I strongly advise
				against this.
				<br />
				<br /> I would also advise against doing it in a public park. You’ll
				want to choose a place where you’ll be alone or in the company of only
				those people who you intend to do this with. You will not want to
				interact with any random people during the entire process, nor will you
				want them to be looking at you while you’re staring intently at tree
				bark, etc.
				<br />
				<br />
			</p>
		</div>
	);
}

export function dmt() {
	return (
		<div>
			<p style={{ textAlign: 'center' }}>
				<h3>
					<i>
						"The only justifiable reason for milking toads right now is to
						analyze the venom, figure out exactly what it contains, and then
						figure out a sustainable, synthetic way to recreate it so that we
						don't need to bother toads"
					</i>
				</h3>
				<i>-Hamilton Morris</i>
				<br />
				<br />
				The Bufo Alvarius toad of the Sonoran Desert has had it's venomous
				secretions milked for decades, because it contains a psychoactive
				substance known as 5-MeO-DMT, which humans like to smoke. Unfortunately,
				the toad's population is very at risk, due to many external factors,
				including climate change, habitat destruction, pesticide contamination,
				and being ran over by cars. As humans, it is our duty to acknowledge
				that this practice is unsustainable, and do what we can to not
				contribute to the destruction of this species as a whole, which only
				breeds once a year. You don't have to be a hero, just don't smoke toad
				venom. The toads will thank you, just as we should be thanking them.
				<br />
				<br />
				There is no significant difference between the experience of smoking
				toad venom and smoking synthetic 5-MeO-DMT. For proof, one need not look
				further than an analysis of the venom itself, where only 17% of the
				venom contains known hallucinogenic substances. 16% is 5-Meo-DMT, and
				the other 1%, at the most, is Bufotenin. Some samples contain no
				Bufotenin at all. At this point, it is best to attribute any difference
				in experience of the two substances to the mental state of the user
				(placebo effect), or a difference in dosage.
				<br />
				<br />
				Luckily, there are synthetic alternatives to smoking toad venom,
				including synthetic 5-MeO-DMT, and NN-DMT, which can be made at home
				with locally bought products and Mimosa Hostilis root bark, which grows
				like a weed in Southern Mexico, and is legal in most countries. NN-DMT
				exists in many other plants as well, and is naturally produced by the
				human body. See below for the synthesis of NN-DMT.
				<br />
				<br />
				<b>Citation for above:</b> Hamilton's Pharmacopeia S3E1
			</p>
			<h1>DMT for the Masses</h1>
			<h2>
				A <i>Mimosa tenuiflora</i> (= M. hostilis) Root-Bark Extraction Tek
			</h2>
			<h3>
				BY NOMAN
				<br />
				v1.4 - Jun 26, 2012
				<br />
				Revised version of an article originally published in
				<i>The Entheogen Review</i>
			</h3>

			<p>
				<b>Citation for this synthesis:</b> Noman. "DMT for the Masses (v
				1.4)". Erowid.org. Jun 26, 2012. Online edition:
				Erowid.org/plants/nutmeg/nutmeg_article#.shtml. Original published
				in The Entheogen Review. Autumn 2006;15(3):91-92.
				<br />
				<br />
				<b>NOTE:</b> Before performing any extraction procedure, it is always a
				good idea to read the entire description of the process from start to
				finish. Please see the Addendum at the end of this tek for additional
				tips, refinements, and clarifications regarding to the processes
				described. Also see the related article “Keep that Mimosa Mud?” by J.
				Cocktoasten.
				<br />
				<br />
				<b>Disclaimer:</b> Performing this procedure is illegal in most
				countries. I do not advocate performing it where illegal and I do not
				perform it myself where illegal.
				<br />
				<br />
				The intent of this tek is to simplify the extraction procedure as much
				as possible, so that the average person can complete it in a kitchen in
				one evening. While I think that I have accomplished this goal,
				experimentalists must still do their homework. It is a good idea to read
				a few different teks before deciding which one to use, and to research
				safe handling procedures for the chemicals and equipment required. I
				don't provide instructions for decanting, siphoning, and filtering, for
				example, because I assume that those interested in performing kitchen
				chemistry will educate themselves on such basic procedures.
				<br />
				<br />
				<h2>Materials</h2>
				<ul>
					<li>
						<i>Mimosa tenuiflora (= M. hostilis)</i> root-bark
					</li>
					<li>
						A coffee grinder or heavy-duty blender (one that will crush ice)
					</li>
					<li>
						A wide-mouthed glass mixing jar with a tight-fitting lid (a quart
						jar can do 50 grams of root-bark, a gallon pickle jar can do 200
						grams)
					</li>
					<li>Water</li>
					<li>Lye (granulated sodium hydroxide)</li>
					<li>A bottle of vinegar (for neutralizing any lye spills)</li>
					<li>A dust mask, safety goggles, and rubber gloves</li>
					<li>Naphtha (VM&P, not lighter fluid)</li>
					<li>
						Four wide-mouthed 8-ounce glass collection jars with lids (canning
						or jelly jars work well)
					</li>
					<li>A separatory funnel or gear to siphon or decant</li>
					<li>Coffee filters</li>
					<li>A rubber spatula</li>
					<li>
						A freezer set to a very cold temperature (it should freeze ice cream
						rock-hard)
					</li>
					<li>
						Non-sudsy ammonia (10% solution, e.g. "janitor strength", is
						optimal, but 5% "household strength" will do as well)
					</li>
					<li>An eyedropper</li>
				</ul>
				<h2>Process</h2>
				1) Snap the Mimosa tenuiflora root-bark into small pieces and run it
				through the coffee grinder or blender at high speed. You may need
				pruning shears to cut the root-bark small enough to grind properly.
				Pulverize it until it is just fiber and pink/purple dust--it needs to be
				completely broken down. The dust produced is very fine and astringent to
				one's respiratory tract. Unless you dig big cakey purple boogers, wear a
				dust mask. After grinding, wait for a bit before opening the top of the
				coffee grinder or blender, so that the dust has some time to settle.
				<br />
				<br />
				2) Combine the lye and the water in the mixing jar. Use 15 ml water and
				1 gram of lye for every gram of powdered root-bark that will later be
				added into the mixing jar. [Note: See Addendum, point #1 below.] For
				example: 50 grams of root-bark powder would require 750 ml water and 50
				grams of lye. One level tablespoon of lye weighs about 15 grams.
				[Note: Lye is dangerous. Blind-you-forever dangerous. Have a bottle of
				vinegar handy as an acid to neutralize the caustically basic lye when
				cleaning up any spills that occur, and wear eye protection and rubber
				gloves when working with lye. Add the lye to the water, while slowly and
				constantly stirring until it has completely dissolved. Always add the
				lye to the water, and not the other way around. Adding water to lye may
				cause a volcano-like reaction. <b>Erowid Note:</b> Dissolving lye in
				water must be done slowly because it causes an exothermic
				(heat-releasing) reaction and this heat can cause dangerous splashing,
				the container to be too hot to touch, and can even crack
				non-borosilicate glassware, all of which could lead to dangerous
				situations.]
				<br />
				<br />
				3) Add the powdered root-bark into the lye/water solution in your mixing
				jar. Cap and shake the jar, then let it sit for about an hour.
				<br />
				<br />
				4) Now add to the mixing jar 1 ml of naphtha for each 15 ml of water
				used to create the lye solution. [Note: See Addendum, point #2 below.]
				Turn the jar end-over-end. Do not shake or splash (or there will be a
				tendency for the solution to form an unwanted emulsion); simply roll the
				naphtha around in the root-bark-powder-solution to mix it. Gently do
				this for one minute, and then let the jar stand until the naphtha has
				mostly separated and is floating on top. Then repeat this agitation
				process three more times.
				<br />
				<br />
				5) After the final agitation, allow enough time to pass for the naphtha
				to again float on top, and then separate the two layers. The naphtha
				(top layer) goes in one of the collection jars, everything else stays in
				the mixing jar. A separatory funnel is the easiest means to accomplish
				separation of the two layers, but various techniques of siphoning or
				decanting could also be employed. None of the dark (lower) solution
				should be allowed into the collection jar--just the naphtha. [Note: If
				you save the dark (lower) basified solution, this can be used to extract
				"jungle spice" from: see Entropymancer 2008. "'Jungle Spice': Mystery
				Alkaloid(s) of <i>Mimosa Root-bark", The Entheogen Review</i> 16(3):
				87-108.]
				<br />
				<br />
				6) Repeat steps 4-5 above three more times, but do not add any new
				powdered root-bark. You will be reprocessing the same original root-bark
				material, in order to thoroughly extract the DMT from it. With the final
				(fourth jar) extraction, leave the powdered root-bark soaking in the
				naphtha for a day or two (agitating it occasionally), to better extract
				any remaining DMT before separating off the naphtha. [Note: See
				Addendum, point #3 below.] When you have finished, place all four
				collection jars into your freezer and go to bed. You will have four
				"snow globes" waiting for you in the morning.
				<br />
				<br />
				7) Pour the naphtha from each jar through a coffee filter, saving the
				naphtha. (The naphtha can be reused for your next batch of extractions,
				or it can be evaporated off to produce a residue that can be further
				refined--see "Recrystallization" below). [Note: It has been pointed out
				that using fresh naphtha for each extraction results in significantly
				better quality material, with less DMT-oxide and oils in the final
				product and a better freeze precipitation.] A lot of paste will stick to
				the jar, so use a small rubber spatula to scrape this paste from the
				jar's sides down into the filter as well. Spread out each filter to dry.
				There will still be some residue in the jars; a bit of 
				<i>Salvia divinorum or Cannabis</i> can be used to scrub them out,
				providing an enhanced aspect to those herbs.
				<br />
				<br />
				8) The paste must be allowed to dry thoroughly; chop and stir it a
				couple of times to make sure that this is the case. Once it seems to be
				dry, crush up any lumps. [Note: Minimize the airflow above your product
				while evaporating-off the solvent and drying the DMT. Having a fan
				blowing above the product (not recommended) has been reported to
				transform white crystals into yellow goo; such airflow may convert some
				of the DMT into DMT-oxide, which is a yellow, sticky goo (and apparently
				not as strong as DMT or different in effect, depending on who you talk
				to).]
				<br />
				<br />
				9) [Note: If you intend to recrystallize your material in order to
				further purify it, you can skip this step. 
				<b>Also, see Addendum, point #4 below.</b>] Combine all of the dried
				material into one coffee filter. Wash this material by pouring freezer
				temperature non-sudsy ammonia over it and through the coffee filter. It
				is imperative that the ammonia you use is of the non-sudsy variety. You
				can shake the bottle to tell; if it creates suds, get a different kind.
				Rinsing won't take much ammonia, about 4 ounces for a 200-gram batch.
				Stir the powder around while rinsing to make sure that all of it is
				thoroughly wetted. A good bit of the mass will wash away--perhaps
				25-45%--but it's nothing you want to be smoking anyway. You should be
				left with about 0.5% of the weight of the root-bark in DMT powder. When
				dried, it is perfectly smokable at this point, but it can be refined
				further by recrystallization. Although recrystallization inevitably
				results in some product loss, once you've had a hit of DMT that left
				absolutely nothing behind in the pipe, you won't want to use anything
				else.
				<br />
				<br />
				<h2>Recrystallization</h2>
				For our current purposes, the idea behind recrystallization is that the
				chosen solvent holds more DMT when hot than when cold, and that some
				impurities remain more easily within cold solvent. While naphtha will
				work for recrystallization, a better solvent to use at this point is
				heptane. Heptane is available in Bestine®, a rubber cement remover
				available at art supply stores. [Note: We have been informed that not
				all types of Bestine® use heptane, so check to make sure that this is
				the sole ingredient.]
				<br />
				<br />
				Place a glass container holding the DMT and a glass container filled
				with the recrystallization solvent together in a pan of hot water. Shot
				glasses in a saucepan work well for a gram or two. The fumes from your
				solvent are extremely flammable, so only use a contained electric
				heating source. (Electric ranges with coil style elements can ignite
				fumes, as can the heat coils in electric ovens. Gas ranges or any sort
				of open flame, obviously, must be avoided.) The DMT will already be
				melting if the water is hot enough. Using an eyedropper, add the hot
				solvent little-by-little while agitating the DMT until all of the
				material has dissolved. Use 20-30 ml of solvent (or less) per gram of
				powder; you want to use as little solvent as possible. When all of the
				material has gone into solution, the solvent will be a clear yellow.
				<br />
				<br />
				Leave the pan of water with the DMT container to cool down to room
				temperature. Then remove the DMT container and place it into your
				refrigerator. Later, move it into your freezer. This step-wise process
				allows for gradual cooling and the precipitation of crystals. You will
				end up with DMT crystals of varying purity on top of a pellet of slag,
				which still contains quite a bit of DMT (but also some lye, if you
				skipped the ammonia wash). Do the coffee filter bit again to dry the
				material, and then separate the crystals from the slag. The crystals can
				be further refined, through one or two more recrystallizations, into
				pure clear DMT. The slag can also be further refined or simply
				redissolved into the next batch. The solvent can be reused or evaporated
				down, with the residue scraped and cleaned. And don't forget to scrub
				those jars and utensils with some of your favorite smoking herb.
				<br />
				<br />
				<h2>Addendum</h2>
				<h3>by Noman and Entropymancer</h3>
				1) If pre-powdered bark is being used, 1.5 to 2 times of the water
				called for will be required. Pre-powdered bark requires more water
				because commercial suppliers pulverize the fibrous bits that a home
				blender (or a coffee bean grinder) leaves intact; this material turns to
				a sludge in the lye solution that won't release the naphtha if it's
				added while the solution is still sludgy.
				<br />
				<br />
				2) Regarding the freeze precipitation process: When the tek was written,
				commonly available Mimosa tenuiflora (= M. hostilis) root-bark was of
				much higher quality than what has been available more recently. Due to
				the lower-quality material, these days a partial evaporation is
				sometimes necessary to get the solution concentrated enough to
				precipitate. Using a bit less naphtha allows the extractions to be
				concentrated enough to freeze-precipitate more reliably. (It may end up
				taking one or two more pulls to get all the DMT, but easy
				freeze-precipitation is a good trade-off for one or two extra pulls.) By
				using around 0.4 ml of heated naphtha per gram of bark, every pull
				except the last one freeze-precipitated easily. (This was with an
				acid/base extraction in a sep funnel, but it should likely work just as
				well with a straight-to-base extraction.)
				<br />
				<br />
				3) Using heat for the last pull will increase the yield. This was left
				out of the original tek for the sake of simplicity, but it is probably
				worth mentioning. [Note: Again, naphtha is flammable. Naphtha-based
				extractions can be warmed by partially submerging the closed extraction
				jar into a hot water bath.]
				<br />
				<br />
				4) Get rid of the ammonia wash. For whatever reason, it seems to cause
				problems for at least half the people that use it. Change it to a wash
				of the naphtha with a weak basic solution. [According to Vovin's Tek:
				Dissolve a pinch of sodium carbonate in about 50 ml or distilled water,
				then add a small amount of this solution (approximately one-twelfth by
				volume) to the naphtha, shake well, then allow the water to separate
				from the naphtha and discard the water. Following this, wash the naphtha
				two more times using pure (non-basified) distilled water (again using an
				amount of approximately one-twelfth by volume). Vovin cautions to avoid
				leaving the water in the naphtha for too long, saying: "no sitting for
				hours letting it 'soak'; you need to get it in and out."]
				<br />
				<br />
				<h3>Notes</h3>
				This is a revised version of a tek published under the same name in 
				<i>The Entheogen Review</i> (see citation above). An error in the
				printed <i>ER</i> version of this article made it appear as though the
				root-bark should be thrice run through a new lye/water mix and then
				extracted with naphtha. This is not the case. The *same*
				lye/water/root-bark should be used in each of the three
				re-processesings; only new <i>naphtha</i> is added each time. -- 
				<b>David Aardvark, The Entheogen Review</b>
			</p>
		</div>
	);
}
export function layingLSD() {
	return (
		<div>
			<h1>How to Lay LSD</h1>
			<p>
				<b>Citation:</b> u/Kman1898 via
				https://www.reddit.com/r/Drugs/comments/2fl2jn/tek_laying_blotter/
			</p>
			<p>Let us assume you can obtain the following.</p>
			<ul>
				<li>
					<p>
						A page of 900 hits of standard commercially available blotter paper
						(this works for anything comparable to Key-Z and Shakedown, must be
						modified for other types of paper based on their absorbancy)
						90-100mg of xtal (to account for any crystal impurities, let us
						assume you use 100, this lays roughly 110 mics per hit of crystal
						which you then have to multiply by your purity, assuming a 95%
						crystal that is 104.5 ug per tab)
					</p>
				</li>
				<li>
					<p>Everclear and Vodka</p>
				</li>
				<li>
					<p>
						Either a 10ml syringe or a 4x3ml syringes (I prefer 4x3ml for a
						later step)
					</p>
				</li>
				<li>
					<p>
						A pyrex dish or porcelain plate that is roughly the same size as
						your page
					</p>
				</li>
				<li>
					<p>
						A drying surface such as a bed of nails or something else with
						limited contact and uniform support. I had a custom glass bed of
						nails made in a pyrex dish, had a blower friend make it for a sheet.
					</p>
				</li>
				<li>
					<p>A magnetic stirrer</p>
				</li>
				<li>
					<p>
						An analytical balance scale if you have more than 100mg of crystal.
						Only an analytical balance good to .1mg will do. That means it can
						determine a difference of 100ug.
					</p>
				</li>
			</ul>
			<p>Now to the tek:</p>
			<ul>
				<li>
					<p>
						First off I can hear you saying, "WOAH Everclear and Vodka, why?
						Don't people just use Everclear?"
					</p>
				</li>
				<li>
					<p>
						To answer this I give you an partial entry from Tihkal. The last
						lines from Synthesis read,
					</p>
				</li>
				<li>
					<p>
						"Repeated recrystallizations from methanol produced a product that
						became progressively less soluble, and eventually virtually
						insoluble, as the purity increased. A totally pure salt, when dry
						and when shaken in the dark, will emit small flashes of white light.
						"
					</p>
				</li>
				<li>
					<p>
						The final part is just to make you smile. But you will note as
						purity increases alcohol solubility decreases, this is why we bring
						out the vodka so that we can assist the solubility by adding water
						that we know is clean and mixed well with alcohol. Most salts, HCL,
						Fumurate, Mallerate and others all are water soluble.
					</p>
				</li>
				<li>
					<p>
						Take your Everclear and your vodka and mix them in the ratio of 8:2
						(Everclear:Vodka). Eight parts Everclear to two parts Vodka. I mix
						solvents to make about 100ml at a time, then store once mixed in an
						airtight container.
					</p>
				</li>
				<li>
					<p>
						Mix it well, preferably using a magnetic stirrer for an hour if not
						use a large 3-10ml syringe and suck and spray it for about 15
						minutes to ensure somewhat uniform mixing.
					</p>
				</li>
				<li>
					<p>
						Now draw back 10 ml into the 10ml syringe, or 2.5ml per 3ml syringe,
						then draw some air for shaking as your solution may want to cloud up
						again (depends on initial mixing) if left too long as it will be
						what chemists call a super saturated solution. ( An important note
						here. Key-z needs about 10 ml of liquid Shakedown only need about
						9ml; it is important that you KNOW your paper).
					</p>
				</li>
				<li>
					<p>Lay your sheet, face down, on your chosen laying dish or plate.</p>
				</li>
				<li>
					<p>
						Take your crystal and put it into a glass container appropriate for
						mixing and drawing liquid from.
					</p>
				</li>
				<li>
					<p>Add your solvent.</p>
				</li>
				<li>
					<p>
						Either using a magnetic stirrer or the suck and blow method, mix the
						living hell out of that crystal. The longer you work it the more the
						stubborn bits will break down and join the solution. Unless you are
						working with sparking crystal there will be some that just won't go.
						You now have the aforementioned super saturated solution.
					</p>
				</li>
				<li>
					<p>
						Once you are done mixing, suck it back into your syringe(s) and cap
						it (them). Allow it to settle for about 2 mins to check for
						cloudiness and then shake it. You will note that your solution may
						be milky and or cloudy, that is because it is several times thicker
						than you would take in liquid. Super saturated. Depending on the
						crystal purity it will cloud more or less than another batch.
					</p>
				</li>
				<li>
					<p>
						If you get your alcohol and water ratio perfect it will not cloud at
						all. You want it to not cloud if possible.
					</p>
				</li>
			</ul>
			<p>
				Note- I prefer 3ml syringes for the next part but will give instructions
				as if you are going to understand the direction I am going.
			</p>
			<ul>
				<li>
					<p>
						If you have it in 4 syringes this part is easier, if it is in 1
						syringe you have to be careful and pay attention to your fourths.
					</p>
				</li>
				<li>
					<p>
						Turning to your sheet, you will need to think of it in fourths as
						well. Top quarter, middle quarters, bottom quarter.
					</p>
				</li>
				<li>
					<p>
						Starting at one end begin to squirt the liquid back and forth across
						the pages working your way down one quarter per syringe or one
						quarter of your syringe, as you do each quarter, tip the sheet (very
						slightly) in the direction of the unfinished areas. Try to work as
						meticulously as possible leaving as little blank space as you can.
					</p>
				</li>
				<li>
					<p>
						Tipping will help extra liquid migrate. And as you do so, you will
						begin to see it migrate from blotter to blotter.
					</p>
				</li>
				<li>
					<p>
						Continue working down towards the end opposite from which you
						started. By the time you have reached the bottom you will have used
						9-9.5 ml of liquid and will probably have had to tip it back to
						avoid run off, be careful here and you will be fine and will lose
						almost nothing. The remaining .3-.5ml you use to cover the last
						spots to have absorbed or spots that look undersaturated and then
						you also tip it a little bit to let is uniformly absorb the rest.
					</p>
				</li>
				<li>
					<p>
						Make sure to tilt your pan or dish to ensure as it is evapping the
						liquid moves into the blotter uniformly, you can see this in the
						moisture content of the paper on the surface. Water also helps with
						this as it slows evap, pure Everclear can create a problem with too
						fast of an evap and crystal dropping out and showing on the surface
						of the blotter.
					</p>
				</li>
				<li>
					<p>
						Once the alcohol has evapped move your sheet to your drying surface.
						Do not move it prematurely, wait until the liquid will not pool or
						cause bowing as liquid will still migrate if left and doing so would
						create hot spots.
					</p>
				</li>
				<li>
					<p>
						Your drying surface should be something like a lipped baking dish
						smaller than your page, or if possible a bed of nails or glass
						nails.
					</p>
				</li>
				<li>
					<p>
						Your sheet will dry relatively swiftly at this point and should be
						ready for and airtight packaging within a half hour to an hour.
					</p>
				</li>
				<li>
					<p>
						Next trip testing, and blacklight checks are in order to ensure you
						have no hot spots.
					</p>
				</li>
				<li>
					<p>
						If those come out, you are golden. Congrats you just laid a full
						page and contrary to the old ChinaCat post, unless you intentionally
						lick up the mop up, or lick solution on your hands, you will not get
						high at all. I have laid 5 grams at a time without getting high. The
						only time I accidentally dose is if I touch my mouth with solution.
					</p>
				</li>
				<li>
					<p>
						Scientific experimentation has proven that bio-availability of LSD
						absorbed through the skin is negligible at best. Nick Sands once
						used 1 gram of LSD in a DMSO-LSD solution and painted his arms with
						it to no effect. But touch those lips or a mucus membrane and that
						is a different story.
					</p>
				</li>
			</ul>
			<p>
				I'd like to add something about blotter absorbency that was briefly
				touched on and subsequently left off of this tek.
			</p>
			<ul>
				<li>
					<p>
						Take said solvent, that doesn't contain LSD, and pull up some in the
						syringe ie 10ml or A. You can use more solvent than would be
						absorbed by the paper because we are just figuring out what's needed
						to fully impregnate the paper.
					</p>
				</li>
				<li>
					<p>Squirt the solution all over the paper, as HoS described.</p>
				</li>
				<li>
					<p>
						After the paper is fully impregnated, draw off the remaining
						solution that's not impregnated aka B and subtract that from the
						10ml or A starting point. This leaves you with A-B=C or the amount
						of solution required to fully impregnate the blotter.
					</p>
				</li>
				<li>
					<p>
						Then use C, when dissolving your LSD into the solvent, to be able to
						properly saturate the blotter paper.
					</p>
				</li>
			</ul>
		</div>
	);
}

export function acetoneWashCoke() {
	return (
		<div>
			<h1>How to Acetone Wash Cocaine or Amphetamines</h1>
			<p>
				<b>Citation:</b> Pill2Chill via
				http://www.dialogue.space/simple-acetone-wash-for-methamphetamines-and-cocaine/
			</p>
			<p>
				<h2>Introduction</h2>
				sekio edit: Without lab testing, you as a layman can only guess at
				purity and composition of substances. Reagent color change tests can
				help to identify pure substances, but are unhelpful at identifying
				mixtures. Judging purity by weighing what you get out of a wash doesn’t
				work, either – there’s no guarantee that the residue is amphetamine.
				Bioassay (“tasting it”) isn’t of any use because of the number of drugs
				that can look and act similarly to amphetamines. Acetone and other
				solvent washes are meant to remove certain cuts you know have been
				added, not to purify or isolate amphetamine out of a mystery mix. (For
				purification of amphetamine out of mystery mixtures, acid/base
				extraction is the gold standard.) You can send drugs – pills, powders,
				or pastes to DanceSafe (http://www.pillreports.com/) or Energy Control
				(http://energycontrol.org/) if you want professional GCMS testing. It’s
				anonymous and worth the money. <br />
				<br />
				Acetone and other solvents are flammable and should never be used around
				sparks or open flames (refrigerators, freezers, electric motors,
				furnaces). The vapours are volatile and can flash back to the container
				and cause a boiling liquid expanding vapour explosion. Always work with
				acetone in a well ventilated area, have something to clean up spills
				like vermiculite or cat litter (or paper towels or sawdust or something
				else absorbent) and wet it with cold water. Remember acetone will eat
				many plastics, paints, and varnishes.
				<br />
				<br />
				Hey, I figured I would write down this simple guide to acetone washing
				as there doesn’t seem to be too much information about it on the forums
				and it definitely has an added HR value. This method works for cocaine
				hcl, amphetamine sulphate and methamphetamine.
				<br />
				<br /> First let’s get this common misconception out of the way.
				Amphetamine paste = Amphetamine sulphate =/= Amphetamine base. Another
				common slang is ‘eurospeed’. The base is an oily liquid that evaporates
				at room temp and is therefore extremely rare. Most people won’t ever
				come accross real amphetamine base unless they turn the sulphate into
				base themselves. Sulphate, or the common amphetamine ‘paste’ is not
				smokable (which real amphetamine base is). The paste is wet simply
				because it has remainders of solvents used in production, or added by
				dealers to add weight. Usually acetone and/or methanol, so it’s wise to
				let your amps dry before using them, even if you’re not cleaning your
				amphetamines, as both of those are very detrimental to the body. You can
				easily dry amphetamine sulphate ‘paste’ by smearing out the wanted
				amount on a DVD case (or whatever you have available), waiting 5 minutes
				and then scraping it together, or if you’re more patient just leave the
				open baggy on the heater and all the solvents will evaporate until
				you’re left with dry amphetamine sulphate.
				<br />
				<br />
				Amphetamine sulphate, as well as cocaine are often cut with caffeine and
				other nasty active ingredients. When you’re 100% certain of your source
				(doubtful in most cases) or can have it tested in a lab (I’m thinking
				Netherlands, Belgium) you will have no use for this method, but if
				you’re buying and using it and do not have that certainty: there’s this
				easy way to clean your amphetamines and remove most of those active
				cuts. (A good indication for caffeine in amphetamines/cocaine is that it
				won’t chop to powder easily; but rather clump together and be a little
				sticky. What you’re left with after an acetone wash will be a product
				that powders very easily and is notably more pure.) It’s very simple;
				basically the nasty active cuts are soluble in acetone whereas
				amphetamines, cocaine and meth are not. A LOT of the cuts will be taken
				out by this method; but if it’s cut with anything that is insoluble in
				acetone, that cut will of course be left behind.
				<h2>Requirements</h2>
				Amphetamine sulphate (duh) this is what it looks like, straight from my
				dealer, uncleaned and in its ‘paste’ form. (aka, a little wet with nasty
				solvents…)
				<img src={cocaineOne} alt="Bag of amphetamine sulphate." />
				Pure acetone. Why pure? If it’s not pure, it’s likely to contain other
				solvents that will dissolve amphetamines, thus making a wash impossible.
				It’s not hard to find; I get mine at the hardware store across the
				street <img src={cocaineTwo} alt="Bottle of acetone." /> a dish This can
				be a simple plate with some depth, as can be seen in the second pic of
				the first item on the list, but there are probably better alternatives.
				Use your imagination.) A syringe and a Q-tip.10ml is best, or even
				bigger is better if you’re using a needle. On the pic below it’s a 5ml I
				believe. (Needle optional, but it does facilitate the process. The gauge
				used in the pic is about right, smaller is fine too but if it’s too thin
				it’ll take more time.)
				<img src={cocaineThree} alt="Syringe and q-tip." />
				Alternatively you could use a coffeefilter, I advise against this as
				more amphetamines gets left behind in the filter this way.
				<h2>Procedure</h2>
				Cut open the baggy, remove the amphetamines, place on tray/plate.
				<img
					src={cocaineFour}
					alt="Plate with open bag of amphetamine on it."
				/>{' '}
				Pour acetone over the amphetamines until it is well covered with
				acetone. If you need a ml amount; 10-15ml per gram is plenty. You can
				use as much as is convenient, just try to make it so you’re not wasting
				too much acetone. Make sure the edge of your tray/dish is high enough so
				you can still stir it without spilling anything. Stir, make sure all the
				amphetamines are spread out and that there’s no “lumps” left. The
				solution in your plate will be cloudy. Give it a minute to settle. Now
				take your syringe, and using the qtip as a filter, draw up the acetone
				with your syringe. Depending on the size of your syringe this can take a
				few times but shouldn’t be too hard.I didn’t use a needle in this wash.
				The settled amphetamines can be clumpy like in the picture as long as it
				was properly stirred.
				<img src={cocaineFive} alt="Drawing acetone up from the plate." /> When
				you’ve drawn up all of the acetone that you used in the plate, and
				squirted it all in a container you’ll be left with a pretty wet white
				paste, scrape this together.
				<img src={cocaineSix} alt="Scraped paste." /> Wait about 10-15mins for
				it to dry. Acetone is very volatile so it wil dissipate in no time. The
				amphetamines you’ll be left with will be much, much purer, and cleaner
				in effects. They will also be more ‘rocky’ instead of sticky (if there
				was caffeine in them), and will chop up to powder a lot faster and
				easier.10 minutes after scraping the amphetamines together, this was the
				result: <img src={cocaineSeven} alt="Dried amphetamines." />
			</p>
		</div>
	);
}
